import { render } from "./studioMenu.vue?vue&type=template&id=21039fa2&scoped=true"
import script from "./studioMenu.vue?vue&type=script&lang=js"
export * from "./studioMenu.vue?vue&type=script&lang=js"

import "./studioMenu.vue?vue&type=style&index=0&id=21039fa2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21039fa2"]])

export default __exports__